import { useEffect, useRef, useCallback } from 'react';
import { useSettingsStore } from '@/shared/stores/settingsStore';

const BGM_SRC = '/assets/audio/The Silent Clue.mp3';

export function BgmPlayer() {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const bgmVolume = useSettingsStore((s) => s.bgmVolume);

  // Sync volume — start playing when turned up, pause when muted
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = bgmVolume;
    if (bgmVolume > 0 && audio.paused) {
      audio.play().catch(() => {});
    } else if (bgmVolume === 0 && !audio.paused) {
      audio.pause();
    }
  }, [bgmVolume]);

  // Only auto-play after user interaction and when volume > 0
  const handleInteraction = useCallback(() => {
    const audio = audioRef.current;
    if (audio && audio.paused && useSettingsStore.getState().bgmVolume > 0) {
      audio.play().catch(() => {});
    }
    document.removeEventListener('click', handleInteraction);
    document.removeEventListener('keydown', handleInteraction);
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleInteraction);
    document.addEventListener('keydown', handleInteraction);
    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };
  }, [handleInteraction]);

  return (
    <audio
      ref={audioRef}
      src={BGM_SRC}
      loop
      style={{ display: 'none' }}
    />
  );
}
